import { render, staticRenderFns } from "./CouponCampaignList.vue?vue&type=template&id=9aeabd20&scoped=true"
import script from "./CouponCampaignList.vue?vue&type=script&lang=js"
export * from "./CouponCampaignList.vue?vue&type=script&lang=js"
import style0 from "./CouponCampaignList.vue?vue&type=style&index=0&id=9aeabd20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aeabd20",
  null
  
)

export default component.exports